import { useState, useMemo } from "react";
import { getTheme } from "../themes";
import { getNextTheme, themes, type Theme } from "../constants/themeConstants";

export interface ColorModeContextType {
  changeTheme: (newTheme: string) => void;
  theme: Theme;
  currentTheme?: string;
}

const useTheme = () => {
  const currentColorMode = themes[0]?.name;
  const [currentTheme, setCurrentTheme] = useState(currentColorMode);

  const changeTheme = (newTheme: string) => {
    const nextMode = newTheme || getNextTheme(currentTheme);
    setCurrentTheme(nextMode);
  };

  const theme = useMemo(() => getTheme() as Theme, [currentTheme]);

  return { changeTheme, theme, currentTheme };
};

export default useTheme;
